import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import importExcel from "@/components/dialog/deptManage/importExcel.vue";
import chargePerson from "@/components/management/reportManage/chargePerson.vue";
import { excelExport } from "@/api/importAndExport/excelApi";
import { getLogData } from "@/api/personalCenter/personalInfo";
import { remote } from "@/api/admin/dict";
import { mapGetters } from "vuex";
export default {
  name: "operationLog",
  //操作日志
  components: {
    importExcel: importExcel,
    chargePerson: chargePerson
  },
  //导出组件
  data: function data() {
    return {
      loading: false,
      tableLoading: false,
      formValidate: {
        username: "",
        tion: ""
      },
      tionList: [{
        tionId: "0",
        tionName: "用户管理"
      }, {
        tionId: "1",
        tionName: "用户管理1"
      }, {
        tionId: "2",
        tionName: "用户管理1"
      }],
      deptData: {
        data: [],
        total: 0
      },
      initPage: {
        current: 0,
        size: 10,
        sizes: [10, 20, 50, 100]
      },
      treeSelect: [],
      uplodData: {
        state: false,
        type: ""
      },
      selectedId: "",
      currenTreeId: null,
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: [],
        type: "radio"
      } //用户弹窗组件数据

    };
  },
  computed: _objectSpread({}, mapGetters(["userData"])),
  created: function created() {},
  mounted: function mounted() {
    this.getRemote();
    this.getTbaleData();
  },
  methods: {
    //获取表格数据
    getTbaleData: function getTbaleData() {
      var _this = this;

      var params = {};

      if (this.formValidate.tion) {
        params = {
          classicType: this.formValidate.tion,
          uids: this.formValidate.username || "",
          current: this.initPage.current,
          size: this.initPage.size
        };
      } else {
        params = {
          uids: this.formValidate.username || "",
          current: this.initPage.current,
          size: this.initPage.size
        };
      }

      getLogData(params).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.deptData.data = data.data.records || [];
          _this.deptData.total = data.data.total;
        } else {
          _this.$message.warning(data.msg || "获取数据异常");
        }
      }).catch(function (err) {
        _this.$message.error(data.msg || "获取数据异常!");
      });
    },
    // 获取功能下拉数据
    getRemote: function getRemote() {
      var _this2 = this;

      remote("log_classic_type").then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this2.tionList = data.data;
        } else {
          _this2.$message.error(data.msg || "数据异常!");
        }
      }).catch(function (err) {
        _this2.$message.error(data.msg || "数据异常!");
      });
    },
    // 展示用户
    addPerson: function addPerson() {
      this.personData.state = true;
      this.$refs.personModal.loadData();
    },
    // 关闭用户选择弹窗并返回所选用户
    closePerson: function closePerson(value) {
      var _this3 = this;

      if (!value.mans) {
        this.personData.state = false;
        return;
      }

      var mans = value.mans || [];
      mans.forEach(function (item) {
        _this3.formValidate.username = item.name;
        _this3.personData.data = [{
          userId: item.userId,
          name: item.name
        }];
        _this3.personData.userData = [item.userId];
      });
      this.personData.state = false;
    },
    isAdmin: function isAdmin() {
      return (this.userData.roleCodes || []).includes("ROLE_ADMIN");
    },
    downloadExcel: function downloadExcel() {
      var _this4 = this;

      this.$DownLoad(excelExport("organ"), null, function (res) {
        if (res.status == 200) {// this.$message.success("开始下载");
        } else {
          _this4.$alert("下载出错,请稍后重试", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      }, function (error) {
        _this4.$alert(error, "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
      });
    },
    cellClass: function cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
    handleSelectionChange: function handleSelectionChange(selection, row) {
      this.selectedId = selection.length > 0 ? row.deptId : "";
      this.$refs.deptTable.clearSelection();
      if (selection.length > 0) this.$refs.deptTable.toggleRowSelection(row);
    },
    transferFn: function transferFn(row) {
      this.getDeptTreeData(row.deptId);
    },
    delDeptFn: function delDeptFn(formName) {
      var _this5 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.moveDeptHttp();
        } else {
          return false;
        }
      });
    },
    uploading: function uploading() {
      this.uplodData.state = true;
      this.uplodData.type = "organ";
    },
    closeUplod: function closeUplod(val) {
      var _this6 = this;

      this.uplodData.state = val; // this.refreshDepartment(
      //     this.initPage.size,
      //     this.initPage.current,
      //     this.treeSelect != null ? this.treeSelect.id : null
      // );

      this.$store.dispatch("getDeptTree").then(function (data) {
        _this6.$store.commit("SET_CHOOSE_DEPT", data.data.data);
      });
    },

    /**
     * @description: 分页
     * @param:{num}
     * @return:
     */
    changePage: function changePage(num) {
      this.initPage.current = num;
      this.getTbaleData();
    },

    /**
     * @description: 选择条数
     * @param:{num}
     * @return:
     */
    handleSizeChange: function handleSizeChange(val) {
      this.initPage.size = val;
      this.initPage.current = 1;
      this.getTbaleData();
    }
  }
};